<template>
  <div>
    <h5>
      {{ local.complaints.newComplaint.complaintCategoryTab.complaintCategoryInput }}
    </h5>
    <v-row class="complain-type-container">
      <v-col cols="12">
        <ul class="complain-type">
          <li
            v-for="(category , index) in complaintCategories"
            :key="index"
          >
            <a
              href="#"
              :class="{'active': selectedCategoryId === category.id}"
              @click="selectCategory(category)"
            > {{ category.name }}</a>
          </li>
        </ul>
      </v-col>
      <v-col
        v-if="mainCategoryDescription"
        cols="12"
      >
        <p class="align-start d-flex text-wrap main-cat-description">
          <v-icon color="#b69a70">
            mdi-lightbulb-on-outline
          </v-icon>
          <span class="ps-1 text--secondary">{{ mainCategoryDescription }}</span>
        </p>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <case-list
        v-if="selectedCategoryId == mainComplaintCategories.relatedToCase"
        :complaint-obj="complaintObj"
      ></case-list>
    </v-row>
    <v-row class="ma-0">
      <execution-verification
        v-if="selectedCategoryId == mainComplaintCategories.relatedToExecution"
        :complaint-obj="complaintObj"
      ></execution-verification>
    </v-row>
    <div class="button-container">
      <naj-button
        class="left-button"
        @click="cancel()"
      >
        {{ local.common.cancel }}
      </naj-button>
      <div class="right-buttons">
        <naj-button
          type="button"
          color="#89743e"
          icon="mdi-arrow-right"
          @click="previous"
        >
          {{
            local.common.previous
          }}
        </naj-button>
        <naj-button
          type="button"
          append-icon
          icon="mdi-arrow-left"
          @click="next"
        >
          {{
            local.common.next
          }}
        </naj-button>
      </div>
    </div>
  </div>
</template>

<script>
import CaseList from './caseList.vue';
import { mainComplaintCategories } from '@/modules/complaints/helpers/enum';
import ExecutionVerification from '@/modules/complaints/components/new-complaint/verification-components/execution-verification.vue';

export default {
  name: 'ComplaintCategoryTab',
  components: {
    CaseList,
    ExecutionVerification,
  },
  props: {
    complaintObj: {
      type: Object,
      default: () => ({}),
    },
    complaintCategories: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      mainComplaintCategories,
      mainCategoryDescription: null,
      selectedCategoryId: null,
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.selectCategory(this.complaintCategories[0]);
  },
  methods: {
    selectCategory(type) {
      if (type.Id != this.mainComplaintCategories.relatedToCase) {
        this.complaintObj.complaintForm.formModel.selectedCase = null;
      }
      this.selectedCategoryId = type.id;
      this.complaintObj.selectedCategoryId = type.id;
      this.mainCategoryDescription = type.description;
      this.complaintObj.verifiedCase = false;
      this.complaintObj.resetFormModel(true);
    },
    previous() { this.$emit('changeTab', 'tab-1'); },
    next() {
      if (this.selectedCategoryId == this.mainComplaintCategories.relatedToCase && !this.complaintObj.complaintForm.formModel.selectedCase)
        this.toaster.error(this.local.complaints.newComplaint.complaintCategoryTab.noCaseSelected);
      else if (this.selectedCategoryId == this.mainComplaintCategories.relatedToExecution && !this.complaintObj.verifiedCase) {
        this.toaster.error(this.local.complaints.newComplaint.complaintCategoryTab.executionErrorMessage);
      } else {
        this.$emit('changeTab', 'tab-3');
      }

    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-header {
  height: 60px;
}
::v-deep .naj-box .naj-box-content {
  white-space: normal !important;
  overflow-wrap: break-word !important;
}
::v-deep .v-input {
  text-align: right !important;
}
::v-deep .v-input.v-input--selection-controls .v-label {
  font-weight: 700;
}
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}
.left-button {
  margin-left: 10px;
}

.right-buttons {
  display: flex;
}

h5 {
  color: #34675a;
  font-weight: 600;
  font-size: 0.9375rem;
  margin-bottom: 1.005rem;
}
.complain-type-container {
  margin-bottom: 2.25rem;
}
.main-cat-description {
  margin-inline: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0;
  .v-icon {
    font-size: 26px !important;
  }
}

.complain-type {
  margin-block-start: 2.25rem;
  margin-top: 0;
  display: flex;
  flex-wrap: wrap;
  padding-right: 0;
  list-style: none;
  gap: 34px;
  margin-inline: 0.5rem;
  li {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center;
    a {
      width: auto;
      padding-left: 0px;
      background-color: #f7f7f7;
      border: 2px solid #fff;
      padding: 0.75rem;
      color: #6c757d;
      &.active {
        color: #fff;
        background-color: #b39a6d !important;
        font-weight: bold;
      }
    }
  }
}
</style>
